import SET_SHOW_BOOT_CAMPS_NAV_LINK from '@data/constants/actionTypes/bootCamps';

const setShowBootCampsNavLink = value => ({
  type: SET_SHOW_BOOT_CAMPS_NAV_LINK,
  value,
});

export default setShowBootCampsNavLink;
